<div class="row">
  <div class="col-md-10">
    <div class="d-flex justify-content-start align-items-center h-100">
      <h4 class="mb-0">Mentor Availablity Slots</h4>
    </div>
  </div>
  <div class="col-md-2">
    <div class="d-flex justify-content-end align-items-center">
      <button class="btn btn-primary addbtn">Download</button>
    </div>
  </div>

  <div class="col-lg-12">
    <div class="card p-3 mt-3">
      <div class="card-block">
        <div class="table-responsive">
          <table datatable id="" class="table table-gr" width="100%">
            <thead>
              <tr>
                <th>S. No.</th>
                <th>Mentor Name</th>
                <th>Total Available Slots</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>1.</td>
                <td>Brijesh Kumar</td>
                <td>17</td>
              </tr>
              <tr>
                <td>2.</td>
                <td>Rahul Singh</td>
                <td>18</td>
              </tr>
              <tr>
                <td>3.</td>
                <td>Ronak Tapadia</td>
                <td>26</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>

<div id="ui-view" [ngClass]="{ 'loding-ui-view': showloding }">
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12 headboxes">
        <div class="card p-0">
          <div class="card-block p-0">
            <div
              class="heading-box"
              style="background-image: url(assets/img/part.png)"
            >
              <div class="row align-items-center">
                <div class="col-md-6">
                  <div class="pagename">
                    <h3 class="card-title">Mentor Availablity Slots</h3>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="total-count">
                    <h5 class="m-0">Total</h5>
                    <h2>{{ mentorAvailSlotsTotal }}</h2>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="excel">
                    <button
                      type="button"
                      *ngIf="exl"
                      title="XL"
                      class="btn btn-primary addbtn ml-3"
                      (click)="exportToExcel()"
                    >
                      <i class="fa fa-file-excel-o"></i>&nbsp;Download
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-lg-12">
        <div class="card">
          <div class="card-block">
            <div id="table" class="table-responsive">
              <table
                datatable
                [dtOptions]="dtOptions"
                [dtTrigger]="dtTrigger"
                class="table"
                width="100%"
              >
                <thead>
                  <tr>
                    <th>S.No.</th>
                    <th>Mentor Name</th>
                    <th>Total Available Slots</th>
                  </tr>
                </thead>
                <tbody *ngIf="mentorAvailList?.length != 0">
                  <tr
                    *ngFor="let item of mentorAvailList; let i = index"
                    [attr.data-index]="i"
                  >
                    <td>{{ getRowNumber(i) }}</td>
                    <td style="width: 18%">{{ item.mentor_name }}</td>
                    <td>{{ item.available_slots }}</td>
                  </tr>
                </tbody>

                <tbody *ngIf="mentorAvailList?.length == 0">
                  <tr>
                    <td colspan="4" class="no-data-available text-center">
                      No data available!
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
